import { Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { DataTable, ToolbarComponent } from '../../../../../components'
import { SchoolInfo, UpdateSchoolInfo } from './PopOver/SchoolInfo'
import SetAdmin from './PopOver/SetAdmin'
import { useNavigate } from 'react-router-dom'
import { schoolHeadCells } from '../../../../../shared/data/headCells'
import { useDispatch, useSelector } from 'react-redux'
import { setSchoolDID } from '../../../../../redux/globalSlice'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
import { highestInt } from '../../../../../shared/utils/constants'

const School = () => {
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)
  const [page, setPage] = React.useState(1)

  const [search, setSearch] = useState('')
  const { data: schooldata, count } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=${page}&limit=${highestInt}`,
  })
  const { data: searchSchool, count: searchCount } = useGlobal({
    userUrl: `${urls.SCHOOL_SEARCH}${search}&page=${page}&limit=${rowsPerPage}`,
  })

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [openSchoolInfo, setSchoolInfo] = useState(false)
  const [admin, setAdmin] = useState(false)
  const [update, setUpdate] = useState(false)

  const rows = search ? searchSchool : schooldata
  const pagecount = search ? searchCount : count
  const handleOpen = () => {
    setSchoolInfo(true)
  }
  const handleClose = () => {
    setSchoolInfo(false)
    dispatch(setSchoolDID(''))
  }
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'School'} subtitle={'Dashboard / School'} />
      <ToolbarComponent
        handleOpen={() => navigate('/registration')}
        search={search}
        setSearchItem={setSearch}
      >
        {/* <FilterSection icon={employee} title={'Set Admin'} /> */}
        {/* <FilterSection icon={FilterIcon} title={'Filter'} /> */}
      </ToolbarComponent>
      <DataTable
        rowData={rows}
        school
        setUpdate={setUpdate}
        headCells={schoolHeadCells}
        handleDetailOpen={handleOpen}
        handleAdminOpen={() => setAdmin(true)}
        pageFee={page}
        setPageFee={setPage}
        pages
        pageCount={pagecount}
      />
      {openSchoolInfo && (
        <SchoolInfo open={openSchoolInfo} handleClose={handleClose} title={'School Information'} />
      )}
      {update && (
        <UpdateSchoolInfo
          open={update}
          handleClose={() => setUpdate(false)}
          title={'School Information'}
        />
      )}
      {admin && <SetAdmin open={admin} handleClose={() => setAdmin(false)} />}
    </div>
  )
}

export default School
